import React, { Component } from "react";
import { Col, Row } from "reactstrap";
import Dialog from "@material-ui/core/Dialog";
import DialogContent from "@material-ui/core/DialogContent";

class OfflinePopup extends Component {
  constructor(props) {
    super(props);
    this.state = {
      isOffline: !navigator.onLine, // Check the initial online status
    };
  }

  componentDidMount() {
    // Add event listeners for online and offline events
    window.addEventListener("offline", this.handleOffline);
    window.addEventListener("online", this.handleOnline);
  }

  componentWillUnmount() {
    // Clean up event listeners
    window.removeEventListener("offline", this.handleOffline);
    window.removeEventListener("online", this.handleOnline);
  }

  handleOffline = () => {
    this.setState({ isOffline: true });
  };

  handleOnline = () => {
    this.setState({ isOffline: false });
  };

  render() {
    const { isOffline } = this.state;
    if (!isOffline) return null; // Don't render the popup if online

    return (
      <Dialog open={this.state.isOffline} style={{ padding: "1em" }}>
        <DialogContent style={{ padding: "1em", overflowY: "hidden" }}>
          <Row>
            <Col md={12} style={{ textAlign: "center" }}>
              <span
                style={{
                  color: "#162c50",
                  margin: "1.1em 1em",
                  padding: "1em",
                }}
              >
                No internet available. Please check your connection.
              </span>
            </Col>
          </Row>
        </DialogContent>
      </Dialog>
    );
  }
}

export default OfflinePopup;
